import { Box, Flex } from '@rebass/grid/emotion'
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import {
  getActiveWizard,
  WizardState,
} from 'views/ProvingDetailsView/PageParticipants'

export enum WIZARD_NAVIGATION {
  previous = -1,
  next = 1,
  cancel = 0,
}
export interface FormFooterWizardProps {
  submitDisabled?: boolean
  nextText?: string | any
  previousText?: string | any
  cancelText?: string | any
  handleWizardChange: (action: WIZARD_NAVIGATION) => void
  wizardState: { state: WizardState; active: boolean }[]
  onSubmitClick: () => void
  onCancelClick: () => void
  onNextClick?: () => void
}

export const FormFooterWizard: React.FunctionComponent<
  FormFooterWizardProps
> = (props) => {
  const { t } = useTranslation()
  return (
    <Flex justifyContent="flex-end">
      {
        <Box px={1}>
          <DefaultButton
            onClick={() => {
              props.handleWizardChange(WIZARD_NAVIGATION.cancel)
              props.onCancelClick()
            }}
          >
            {getActiveWizard(props.wizardState) === 1
              ? 'Abbrechen'
              : props.cancelText}
          </DefaultButton>
        </Box>
      }

      {getActiveWizard(props.wizardState) >= 3 && (
        <Box px={1}>
          <DefaultButton
            onClick={() => {
              props.handleWizardChange(WIZARD_NAVIGATION.previous)
            }}
            disabled={getActiveWizard(props.wizardState) < 3}
          >
            {props.previousText || t('action.save')}
          </DefaultButton>
        </Box>
      )}
      <Box px={1}>
        <PrimaryButton
          onClick={() => {
            props.onSubmitClick()
          }}
          disabled={props.submitDisabled}
        >
          {getActiveWizard(props.wizardState) === props.wizardState.length - 1
            ? 'Fertig'
            : 'Weiter'}
        </PrimaryButton>
      </Box>
      {getActiveWizard(props.wizardState) !== WizardState.addParticipant &&
        getActiveWizard(props.wizardState) !== props.wizardState.length - 1 && (
          <Box px={1}>
            <DefaultButton
              onClick={() => {
                if (
                  getActiveWizard(props.wizardState) ===
                  props.wizardState.length - 1
                ) {
                  props.handleWizardChange(WIZARD_NAVIGATION.cancel)
                  props.onCancelClick()
                } else {
                  props.handleWizardChange(WIZARD_NAVIGATION.next)
                  if (props.onNextClick) {
                    props.onNextClick()
                  }
                }
              }}
              disabled={
                false ||
                getActiveWizard(props.wizardState) ===
                  WizardState.addParticipant
              }
            >
              {getActiveWizard(props.wizardState) ===
              props.wizardState.length - 1
                ? 'Fertig'
                : props.nextText}
            </DefaultButton>
          </Box>
        )}
    </Flex>
  )
}

export default FormFooterWizard
